import { ColumnDef, ColumnDefByColName } from './ModelDef'

type ColumnDefWithKeyAndModelName = {
  columnDef: ColumnDef
  modelName: string
}

/**
 * ネストされたカラム名 の labels を返す
 */
export const getColumnLabelPathsFromColumnDefs = (
  baseModelName: string,
  colNames: string[],
  columnDefByColName: ColumnDefByColName = $core.$models[baseModelName]?.columns || {},
): string[] => {
  const columnDefs = getColumnDefsWithNestedColumnNames(
    baseModelName,
    colNames,
    columnDefByColName,
  )
  return columnDefs.map((colDef) => colDef.columnDef.label || colDef.columnDef.name)
}

/**
 * ネストされたカラム名を含む ColumnDef を返す with modelName
 * - RELATIONSHIP_MANY_TO_ONE である場合、対象の Model に 行って、その Model のカラムを取得する
 * - ARRAY_OF_OBJECT である場合は columns props を返す
 */
export const getColumnDefsWithNestedColumnNames = (
  baseModelName: string,
  colNames: string[],
  columnDefByColName: ColumnDefByColName = $core.$models[baseModelName]?.columns || {},
): ColumnDefWithKeyAndModelName[] => {
  const columns: ColumnDefWithKeyAndModelName[] = []
  colNames.reduce(
    (
      cur: {
        columnDefByColName: ColumnDefByColName
        modelName: string
      },
      colName,
    ) => {
      const colDef = cur.columnDefByColName[colName]
      if (!colDef) {
        console.warn(
          `[getColumnDefsWithNestedColumnNames] colDef is not found for colName: ${colName}`,
        )
        return {}
      }
      columns.push({
        columnDef: colDef,
        modelName: cur.modelName,
      })
      if (colDef?.type === 'RELATIONSHIP_MANY_TO_ONE') {
        const relationModelName = colDef.relationshipManyToOne?.collectionName
        return {
          columnDefByColName: $core.$models[relationModelName]?.columns || {},
          modelName: relationModelName,
        }
      }
      if (colDef?.type === 'RELATIONSHIP_ONE_TO_MANY') {
        const relationModelName = colDef.relationshipOneToMany.collectionName
        return {
          columnDefByColName: $core.$models[relationModelName]?.columns || {},
          modelName: relationModelName,
        }
      }
      if (colDef?.type === 'ARRAY_OF_OBJECT') {
        return {
          columnDefByColName: colDef.columns || {},
          modelName: cur.modelName,
        }
      }

      return {
        columnDefByColName: cur.columnDefByColName?.[colName]?.columns || {},
        modelName: cur.modelName,
      }
    },
    {
      columnDefByColName,
      modelName: baseModelName,
    },
  )
  return columns
}
